declare global {
  interface Window {
    leagueSDKsPresent?: Record<string, string[]>;
  }
}

if (
  typeof window !== 'undefined' &&
  !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')
) {
  // DevTools uses this global as a cheap League SDK presence signal.
  window.leagueSDKsPresent = window.leagueSDKsPresent || {};
}

export {};
